import { render, staticRenderFns } from "./SabeeliAcademy.vue?vue&type=template&id=26fde7b6&scoped=true&"
import script from "./SabeeliAcademy.vue?vue&type=script&lang=js&"
export * from "./SabeeliAcademy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fde7b6",
  null
  
)

export default component.exports